/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const BrokerDetailsR = t.interface({
  broker_code: t.string,

  description: t.string,

  enabled: t.boolean,

  extended_fault_bean: t.boolean
});

// optional attributes
const BrokerDetailsO = t.partial({});

export const BrokerDetails = t.intersection(
  [BrokerDetailsR, BrokerDetailsO],
  "BrokerDetails"
);

export type BrokerDetails = t.TypeOf<typeof BrokerDetails>;
